export interface DashBoardState {
  loading: boolean;
  loadingTopSessions: boolean;
  loadingCoachingHours: boolean;
  loadingSessionsOverview: boolean;
  LoadingExpertEngagement: boolean;
  loadingExpertEarning: boolean;
  topSessions: TopSessions[];
  coachingHours: CoachingHours[];
  sessionsOverview: {
    bookedSessions: number;
    completedSessions: number;
    pendingSessions: number;
  }
  expertEngagement:{
    likes:number;
    comments:number;
  }
  expertEarning: {
    pendingProfileEarnings: number[];
    pendingSessionEarnings: number[];
    profileEarnings: number;
    sessionEarnings: number;
  }
}

export interface TopSessions {
  purchases:number;
  meta:{
    title:string;
    description:string;
    sessionType:string;
    pricingType:string;
    fee:string;
    isCompleted:boolean;
  }
}

export interface CoachingHours {
  totalDuration:number;
  sessionType:string;
}

export interface GetExpertAnalyticsParams {
  entId:string;
  expertId:string;
  startDate:string;
  endDate:string;
}

export interface GetExpertAnalytics {
  payload: GetExpertAnalyticsParams;
  type: string;
}

export interface GetExpertEarningsParams {
  currency :string;
  timeRange :string;
}

export interface GetExpertEarnings {
  payload: GetExpertEarningsParams;
  type: string;
}

export interface GetExpertEarningsReposnse {
  pendingProfileEarnings: number[];
  pendingSessionEarnings: number[];
  profileEarnings: number;
  sessionEarnings: number;
}

export enum ExpertEarningTimeRange {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum AnalyticsTypes {
  EXPERT_TOP_SESSIONS = 'EXPERT_TOP_SESSIONS',
  EXPERT_COACHING_HOURS = 'EXPERT_COACHING_HOURS',
  EXPERT_SESSIONS_OVERVIEW = 'EXPERT_SESSIONS_OVERVIEW',
  EXPERT_ENGAGEMENT = 'EXPERT_ENGAGEMENT',
  EXPERT_EARNING = 'EXPERT_EARNING',
}

export interface IWebsocketResponse {
  type:AnalyticsTypes,
  response:any
  connected?:boolean
}
